import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { LogIn, Loader2, Eye, EyeOff } from 'lucide-react';
import { useAuth } from './AuthContext';

export default function AdminLogin() {
  const { admin, ready, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (ready && admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Login berhasil');
      nav('/admin');
    } catch (err) {
      const msg =
        err?.response?.data?.detail || err?.message || 'Login gagal';
      toast.error(typeof msg === 'string' ? msg : 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-neutral-900 rounded-3xl p-8 border border-neutral-800"
        data-testid="admin-login-form"
      >
        <div className="mb-8">
          <p className="text-xs tracking-[0.25em] text-red-400 font-semibold mb-2">
            POWERX CMS
          </p>
          <h1 className="font-display text-3xl font-bold">Masuk Admin</h1>
          <p className="text-sm text-neutral-400 mt-2">
            Kelola konten dan konfigurasi website.
          </p>
        </div>

        <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">
          Email / Username
        </label>
        <input
          type="text"
          required
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input"
          className="mt-2 mb-5 w-full bg-neutral-800 border border-neutral-700 focus:border-red-500 outline-none rounded-xl px-4 py-3 text-sm"
          placeholder="admin"
        />

        <label className="text-xs uppercase tracking-wider text-neutral-400 font-semibold">
          Password
        </label>
        <div className="relative mt-2 mb-6">
          <input
            type={showPassword ? 'text' : 'password'}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input"
            className="w-full bg-neutral-800 border border-neutral-700 focus:border-red-500 outline-none rounded-xl pl-4 pr-12 py-3 text-sm"
            placeholder="••••••••"
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            data-testid="admin-password-toggle"
            aria-label={showPassword ? 'Sembunyikan password' : 'Tampilkan password'}
            className="absolute inset-y-0 right-3 flex items-center text-neutral-400 hover:text-white transition-colors"
          >
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="w-full inline-flex items-center justify-center gap-2 bg-px-red hover:bg-red-700 disabled:opacity-60 font-semibold py-3.5 rounded-full transition-colors"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" /> Memproses...
            </>
          ) : (
            <>
              <LogIn className="w-4 h-4" /> Masuk
            </>
          )}
        </button>
      </form>
    </div>
  );
}
